/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindPasswordConfirmRequestDto } from '../../models/find-password-confirm-request-dto';
import { FindPasswordConfirmResponseDto } from '../../models/find-password-confirm-response-dto';

export interface PostUserControllerFindPasswordConfirm$Params {
      body: FindPasswordConfirmRequestDto
}

export function postUserControllerFindPasswordConfirm(http: HttpClient, rootUrl: string, params: PostUserControllerFindPasswordConfirm$Params, context?: HttpContext): Observable<StrictHttpResponse<FindPasswordConfirmResponseDto>> {
  const rb = new RequestBuilder(rootUrl, postUserControllerFindPasswordConfirm.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindPasswordConfirmResponseDto>;
    })
  );
}

postUserControllerFindPasswordConfirm.PATH = '/api/user/find-password-confirm';
